<template>
  <div class="filter-container" :class="isOpen ? 'active' : ''" ref="dropdown">
    <button class="filter-btn" @click="isOpen = !isOpen">
      {{ name }}
      <font-awesome-icon icon="angle-down" fixedWidth class="icon closed"/>
      <font-awesome-icon icon="angle-up" fixedWidth class="icon open"/>
    </button>
    <div class="filter-options">
      <b-form-checkbox-group v-model="myselection">
        <b-form-checkbox v-for="(item, index) in items" :key="index" :value="item.value" @change="clickonit">{{ item.text }}</b-form-checkbox>
      </b-form-checkbox-group>
    </div>
  </div>
</template>

<style lang="scss">
@import "../assets/styles/main.scss";
.filter-container {
  margin-left: 10px;
  position: relative;

  .filter-btn {
    background: none;
    border-radius: 3px;
    padding: 5px 50px 5px 10px;
    border: none;
    font-weight: $font-weight-semibold;
    font-size: 1rem;
    transition: all 200ms;

    .icon {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);

      &.open {
        display: none;
      }
    }

    &:hover {
      background: $ui-gray-lighter;
    }
  }

  .filter-options {
    position: absolute;
    padding: 10px;
    background: #fff;
    border: 1px solid $ui-gray-lightest;
    box-shadow: 1px 2px 10px 0 rgba($ui-dark, 0.2);
    border-radius: 3px;
    top: 120%;
    display: none;
  }

  &.active {
    .filter-btn {
      background: $ui-green;
      color: #fff;

      .icon {
        &.open {
          display: block;
        }

        &.closed {
          display: none;
        }
      }
    }

    .filter-options {
      display: block;
    }
  }
}
</style>

<script>
export default {
  name: "DropdownFilter",
  components: {},
  props: {
    filterType: {
      type: String
    },
    name: {
      type: String
    },
    items: {
      type: Array,
      default: () => {
        return [];
      }
    },
    singleselect: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    selected: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      isOpen: false,
      myselection: []
    };
  },
  created() {
    this.handleFilterClick();
  },
  methods: {
    /**
     * Handle the click on the filter element. If the user clicks outside it, the modal is closed.
     *
     * @return {viod}
     */
    handleFilterClick() {
      window.addEventListener("click", e => {
        if (!this.isFilterElement(e.target)) {
          this.isOpen = false;
        }
      });
    },
    /**
     * Check if the click happens on the filter dropdown or not.
     *
     * @param  {Event}  e
     * @return {Boolean}
     */
    isFilterElement(e) {
      if (
        !e.parentNode ||
        e.parentNode.toString() === "[object HTMLDocument]"
      ) {
        return false;
      }
      if (e.parentNode === this.$refs.dropdown) {
        return true;
      }
      return this.isFilterElement(e.parentNode);
    },
    clickonit(e) {
      // if singleselect, set the array to the selected checkbox value
      if(this.singleselect) {
        this.myselection = [ e ];
      }
    }
  },
  watch: {
    myselection: {
      handler: function() {
        this.$emit('selectionChanged', this.myselection);
      }
    },
    selected: {
      handler: function() {
        this.myselection = this.selected;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DropdownFilter.vue